import React from 'react';
import ProjectCard from '../ProjectCard/ProjectCard';
import './Projects.css';

function Projects({ projects, openProjectModal, projectsError, isLoading }) {
  const hasProjects = projects.length > 0;
  const stateTitle = isLoading
    ? 'Loading projects...'
    : projectsError || 'No projects are available right now.';

  return (
    <section className="portfolio-section portfolio" id="projects">
      <div className="section-heading">
        <span className="section-kicker">Projects</span>
        <h2 className="section-title">Selected work.</h2>
        <p className="section-description">
          Projects developed over time across software, electronics, media and
          audiovisual experimentation.
        </p>
      </div>

      {hasProjects ? (
        <div className="projects">
          {projects.map((project, index) => (
            <ProjectCard
              key={project.title}
              index={index + 1}
              title={project.title}
              description={project.description}
              icon={project.icon}
              skills={project.skills}
              onClick={() => openProjectModal(project)}
            />
          ))}
        </div>
      ) : (
        <div className="projects-state" role="status" aria-live="polite">
          <strong>{stateTitle}</strong>
          {!isLoading && (
            <span>
              The page is still safe to browse, but the portfolio data could not be loaded.
            </span>
          )}
        </div>
      )}
    </section>
  );
}

export default Projects;
